import React from "react";
import { Utensils, Flame, Leaf } from "lucide-react";
import { Card, CardContent, CardDescription, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ElSaborDeOrzuna() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const flavors = [{
    title: "Fiestas\xA0",
    description: "Desde el momento en que llegan tus invitados, nos aseguramos de que sean tratados con la misma atención y amor que le damos a nuestra propia familia. No te preocupes y enfocate a crear recuerdos con tu familia y amigos. ",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558956/img/3.png",
    badge: "Servicio Favorito ",
    icon: <Flame className="w-4 h-4" />
  }, {
    title: "Preparacion de Comida\xA0",
    description: "El servicio de preparación de comidas y entrega de almuerzos de **Banquetes Orzuna** lleva el sabor comodo y vibrante de una comida mexicana casera directamente a tu hogar u oficina en Indianapolis. Ya sea que necesites una comida satisfactoria a mitad del día o una cena familiar sin complicaciones, Nosotros cocinamos para que tú no tengas que hacerlo.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558956/img/23.png",
    badge: "Comida como en casa",
    icon: <Utensils className="w-4 h-4" />
  }, {
    title: "Taquiza\xA0",
    description: "Atrae el ambiente y enérgia cultura de la comida callejera de México directamente a tu patio, salón de eventos o reuniónes. Instalamos una estación de tacos tradicional en tu evento, llenando el aire con los irresistibles aromas de carnes asándose y tortillas calientes.\nEs la opción perfecta y del agrado de todos para cumpleaños, graduaciones, bodas casuales y cualquier celebración en la que desees un ambiente divertido, relajado e inolvidable.",
    image: "https://banquetesorzuna.com/wp-content/uploads/2026/03/2-2.jpg?v=5uydr8nrmh",
    badge: "El especial del chef ",
    icon: <Leaf className="w-4 h-4" />
  }];
  return <section id="el-sabor-de-orzuna" className="dark bg-background text-foreground py-24 px-4 md:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div ref={ref} className={`text-center mb-16 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-4xl md:text-5xl font-serif font-bold mb-4 text-foreground">Servicios&nbsp;</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-light">De taquizas a lonches preparados, estamos para servirles. </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {flavors.map((item, i) => <div key={i} data-index={i} className={`transition-all duration-1000 delay-${i * 200} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
              <Card className="h-full border-none bg-card overflow-hidden group hover:shadow-2xl transition-shadow duration-300">
                <div className="relative h-72 w-full overflow-hidden">
                  <img src={item.image} alt={item.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  <div className="absolute top-4 right-4">
                    <Badge className="bg-[var(--color-chart-3)] text-black hover:bg-[var(--color-chart-3)]/90 font-bold px-3 py-1 shadow-lg border-none">
                      {item.badge}
                    </Badge>
                  </div>
                </div>
                <CardContent className="p-8 flex flex-col gap-4">
                  <div className="flex items-center gap-2 text-[var(--color-chart-3)]">
                    {item.icon}
                    <span className="text-xs font-bold tracking-widest uppercase">
                      {i === 0 ? "Autentico" : "AUTENTICO"}
                    </span>
                  </div>
                  <CardTitle className="font-serif text-3xl text-foreground">
                    {item.title}
                  </CardTitle>
                  <CardDescription className="text-muted-foreground text-base leading-relaxed">
                    {item.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}